/*
 * Created on Mon 01 Nov 2021
 *
 * Copyright (c) 2021 Synsoft
 */


import { lazy } from "react";

const Artist = lazy(() => import("../layouts/artistLayout"));

const Subscriber = lazy(() => import("../layouts/subscriberLayout"));

const Page = lazy(() => import("../layouts/PagesLayout"));

const Admin = lazy(() => import("../layouts/adminLayout"));


const indexRoutes = [
  // routes for admin login 
  { path: "/admin", component: Admin },
  
  //route after login as artist.
  { path: "/artist", component: Artist },

  //route after login as subscriber.
  { path: "/subscriber", component: Subscriber },

  //routes before login.
  { path: "/", component: Page },

];

export default indexRoutes;
